import { api } from '../../../services/api'

/**
 * Sync user logged Auth0.
 *
 * @endpoint POST /api/me/identities/sync
 * @scope shared
 * @see missing
 */
export async function syncUserIdentities(): Promise<void> {
  await api.post('/api/me/identities/sync')
}
